import { Box } from '@mui/material';
import { OrgThemedButton } from 'components/OrgThemedButton';
import { useHandleEndLiveChat } from 'components/App/hooks/useHandleEndLiveChat';

export const SuncoSubmitCsatButton = ({
  csatLink,
  csatText,
}: {
  csatLink: string;
  csatText?: string;
}) => {
  const handleEndLiveChat = useHandleEndLiveChat({
    /**
     * We don't want to send "User left the chat" message after Sunco CSAT,
     * because it will change ticket status from "Closed" to "Open".
     */
    shouldSendUserLeftMessage: false,
  });

  return (
    <Box mb='16px' ml='32px' mt='-8px'>
      <OrgThemedButton
        component='a'
        href={csatLink}
        onClick={() => {
          // Automatically end the chat after 5 seconds after the user clicked on the submit CSAT link
          setTimeout(handleEndLiveChat, 5000);
        }}
        rel='noopener'
        target='_blank'
        variant='contained'
      >
        {csatText || 'Submit rating'}
      </OrgThemedButton>
    </Box>
  );
};
